import React from "react";
import "./Services.css";
import posthog from "posthog-js";

const Services = () => {
  const enabled = posthog.isFeatureEnabled("services_enabled");

  if (!enabled) {
    return(
     <section className="pageWrap">
      <div className="pageContainer">
        <h1 className="pageHeading">Our Services</h1>
        <p className="pageText">
          Page is in development stage, Stay tuned.
        </p>
      </div>
    </section>
    );
  }

  return (
    <section className="pageWrap">
      <div className="pageContainer">
        <h1 className="pageHeading">Our Services</h1>
        <p className="pageText">
          At Softations, we provide cutting-edge digital solutions designed to help
          businesses grow, automate, and scale. Our services blend modern
          technology with elegant design, ensuring seamless user experience and
          strong performance across platforms.
        </p>
      </div>
    </section>
  );
};

export default Services;
